// src/App.tsx
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/Approutes';
import './styles/global.css?v=1.0.1'; // Change version when you update styles
import { TTSProvider } from './contexts/TTSContext';

// ✅ Import Vercel Analytics
import { Analytics } from '@vercel/analytics/react';

const App: React.FC = () => {
  return (

      <TTSProvider>
        <Router>
          <div className="App">
            <AppRoutes />
            {/* ✅ Analytics goes here so it tracks across all routes */}
            <Analytics />
          </div>
        </Router>
      </TTSProvider>
  );
};

export default App;
